import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';
import { Link } from 'react-router-dom'

const AlternativeProductDetail = ({manufacturer, title, tid}) => (
    <Col className="alternative-product-detail" md="6" xs="12">
        <Link to={`/asset/${tid}`}>
            <p className="page-detail" id="manufacturer">{manufacturer}</p>
            <p className="alternative-product-detail-text" id="name">{title}</p>
        </Link>
    </Col>
)

AlternativeProductDetail.propTypes = {
    manufacturer: PropTypes.string,
    name: PropTypes.string
}

export default AlternativeProductDetail;



// WEBPACK FOOTER //
// ./src/components/AlternativeProductDetail/AlternativeProductDetail.js